<script>
    import Mixin from "../Mixin";
    export default {
        mixins: [Mixin],
    }
</script>
